<template>
	<div id="firstAccessForm">
		<h3>
			{{ $t('TestResults') }}
		</h3>

		<span class="text-muted"> {{ $t('InputProtocolNumberAndPassword') }}</span>

		<br><br>

		<div class="alert" :class="{'alert-danger': credentials.callback.error, 'alert-success': !credentials.callback.error}" v-if="credentials.callback.message">{{credentials.callback.message}}</div>

		<form v-on:submit.prevent="submitLogin">
			<div class="form-group">
				<div class="input-group mb-2">
					<div class="input-group-prepend">
						<div class="input-group-text">
							<i class="material-icons">person</i>
						</div>
					</div>
					<input type="text" v-mask="['XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX']" required class="form-control pr-login-input" v-model="credentials.login" name="loginProtocolo" ref="loginProtocolo" :placeholder="$t('ProtocolNumber')" />
				</div>
			</div>

			<div class="form-group">
				<div class="input-group mb-2">
					<div class="input-group-prepend">
						<div class="input-group-text"><i class="material-icons">lock</i></div>
					</div>
					<input type="text" v-mask="['XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX']" required class="form-control pr-login-input" v-model="credentials.password" name="loginProtocoloPassword" ref="loginProtocoloPassword" :placeholder="$t('Password')" />
				</div>
			</div>

			<button type="submit" class="btn btn-block shadow-sm btn-light-blue">{{ $t('Access') }}</button>
		</form>
	</div>
</template>

<script>
import { Auth } from "@/services";

export default {
	name: "loginFirstAccessPage",
	data() {
		return {
			credentials: {
				login: "",
				dtnasc: null,
				password: "",
				callback: {
					message: null,
					error: null
				}
			}
		};
	},
	mounted() {
		const urlParams = new URLSearchParams(window.location.search);
		this.credentials.login = urlParams.get('protocol');
		this.credentials.password = urlParams.get('password');
	},
	methods: {
		submitLogin(ev) {
			this.credentials.callback.error = null;
			this.credentials.callback.message = this.$t('Verifying') + '...';

			Auth.loginPatient({
				login: this.credentials.login.replace("-", ""),
				password: this.credentials.password.replace("-", ""),
				loginMethod: "PROTOCOLO"
			})
				.then(response => {
					this.credentials.callback.error = false;
					this.credentials.callback.message = this.$t('PleaseWait');

					localStorage.setItem("Authorization", response.data.token);
					Auth.setToken(response.data.token);
				})
				.then(() => {
					Auth.setAuthenticated().then(response => {
						if(this.$ga)
							this.$ga.event({
								eventCategory: 'login',
								eventAction: 'login-protocol-password',
								eventLabel: 'Autenticação Protocolo/Senha'
							})
						
						this.$router.push({ name: "patientExams" });
					});
				})
				.catch(error => {
					this.credentials.callback.error = true;
					this.credentials.callback.message = this.$t('UnauthorizedAccessTryAgain');
				});
		}
	}
};
</script>

<style lang="scss">
@import '../../assets/_vars';
#firstAccessForm {
	padding: 8px;

	.input-group-text {
		//width: 102px;
		background: #f5f5f5;
	}

	.btn-light-blue {
		background: #f5f5f5;
		color:rgba(0,0,0,0.5);

		&:hover {
			color:#fff;
			background:$lightBlue;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/login/loginFirstAccessPage.vue